/**
 * Valida un tag de idioma antes de pasarlo a Intl (web + mobile, función pura).
 *
 * Algunos navegadores reportan en `navigator.language` tags que Intl rechaza
 * (ej: "es_AR" con guion bajo, "C", valores vacíos o armados a mano). Con esos
 * valores `new Intl.NumberFormat(tag)` / `toLocaleDateString(tag)` tiran
 * `RangeError: Invalid language tag` y la pantalla queda en blanco (caso real:
 * calculadoras y precios públicos, auditoría SEO 2026-09).
 *
 * - Normaliza "_" → "-" (formato POSIX → BCP 47).
 * - Si Intl sigue rechazando el tag, devuelve el fallback ('es-AR').
 */
export const DEFAULT_LOCALE = 'es-AR';

export function toSafeLocale(tag: string | null | undefined, fallback: string = DEFAULT_LOCALE): string {
  if (!tag || typeof tag !== 'string') return fallback;
  const normalized = tag.trim().replace(/_/g, '-');
  if (!normalized) return fallback;
  try {
    // Lanza RangeError si el tag es inválido; existe en web y en Hermes.
    new Intl.NumberFormat(normalized);
    return normalized;
  } catch {
    return fallback;
  }
}
